import React from 'react';
import Projects from '../../Components/Projects/projects';

function ProjectsPage() {
  return (
    <Projects />
  )
}

export default ProjectsPage ;